(function () {
  var container = document.getElementById('upload-design-generator');
  if (!container) return;

  var canvas = document.getElementById('upload-design-canvas');
  var ctx = canvas.getContext('2d');
  var fileInput = document.getElementById('upload-file');
  var qualityEl = document.getElementById('upload-quality');
  var errorEl = document.getElementById('upload-error');
  var resetBtn = document.getElementById('upload-reset-btn');
  var hintEl = document.getElementById('upload-hint');
  var previewModal = document.getElementById('upload-preview-modal');
  var previewImg = document.getElementById('upload-preview-img');
  var previewApprove = document.getElementById('upload-preview-approve');
  var previewCancel = document.getElementById('upload-preview-cancel');
  var previewCheckbox = document.getElementById('upload-preview-checkbox');
  var aifitBtn = document.getElementById('upload-aifit-btn');
  var aifitNote = document.getElementById('upload-aifit-note');

  var API_ENDPOINT = container.dataset.apiEndpoint;
  var API_KEY = container.dataset.apiKey || '';
  var PRODUCT_IMAGE = container.dataset.productImage;

  // Print target dimensions for quality check
  var PRINT_WIDTH = 7088;
  var PRINT_HEIGHT = 5400;

  // Insert area (frame boundary)
  var insertRect = { x: 0, y: 0, w: 0, h: 0 };

  // User image position/scale state
  var imgState = { x: 0, y: 0, w: 0, h: 0 };

  var frameImg = null;
  var currentImg = null;
  // The customer's original image, before any Fit-to-Sign padding. Auto Fit
  // always works from this so repeated clicks are idempotent — the design
  // locks at the fit margin instead of shrinking inside its own padding.
  var fitSourceImg = null;
  var uploadInProgress = false;
  var rotation = 0; // degrees: 0, 90, 180, 270

  // Interaction state
  var dragging = false;
  var resizing = false;
  var rotating = false;
  var rotateStartAngle = 0;
  var rotateStartRotation = 0;
  var resizeStartDist = 0;
  var pointerStart = { x: 0, y: 0 };
  var imgSnapshot = { x: 0, y: 0, w: 0, h: 0 };
  var pinchStartDist = 0;

  // --- Text layers (ported from the dashboard editor; keep in sync) ---
  // Position/size are stored as fractions of the insert area so the same
  // painter renders the live preview and the print-resolution export.
  var textLayers = [];
  var selectedTextId = null;
  var draggingTextId = null;
  var resizingTextId = null;
  var pinchTextId = null;
  var textDragStart = { x: 0, y: 0 };
  var textSnapshot = { xPct: 0, yPct: 0 };
  var textResizeStart = { dist: 0, sizePct: 0 };
  var pinchTextStartSize = 0;
  var textIdSeq = 0;

  // Same families as the dashboard tool (parity), ordered so similar looks sit
  // together in the chip strip.
  var TEXT_FONTS = [
    'Anton', 'Bebas Neue', 'Oswald', 'Alfa Slab One', 'Luckiest Guy', 'Archivo Black',
    'Montserrat', 'Poppins', 'League Spartan', 'Raleway',
    'Playfair Display', 'Abril Fatface', 'Lora', 'Merriweather',
    'Dancing Script', 'Great Vibes', 'Pacifico', 'Caveat', 'Permanent Marker',
    'Fredoka', 'Righteous', 'Bangers'
  ];
  var DEFAULT_TEXT_FONT = TEXT_FONTS[0];

  // Fonts load lazily on the first "Add Text" tap, so the product page's LCP
  // is untouched when the tool isn't used.
  var textFontsRequested = false;
  function ensureTextFonts() {
    if (textFontsRequested) return;
    textFontsRequested = true;
    var families = TEXT_FONTS.map(function (f) { return f.replace(/ /g, '+'); }).join('&family=');
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=' + families + '&display=swap';
    link.onload = function () {
      // Redraw as faces arrive so canvas text picks up the real typeface.
      if (document.fonts) {
        TEXT_FONTS.forEach(function (fam) {
          document.fonts.load('64px "' + fam + '"').then(draw).catch(function () {});
        });
      }
    };
    document.head.appendChild(link);
  }

  var INSERT_PCT = {
    x: parseFloat(container.dataset.insertX) / 100 || 0.12,
    y: parseFloat(container.dataset.insertY) / 100 || 0.08,
    w: parseFloat(container.dataset.insertWidth) / 100 || 0.76,
    h: parseFloat(container.dataset.insertHeight) / 100 || 0.76,
  };

  var productFormEl = document.querySelector('product-form');

  function computeInsertRect() {
    insertRect.x = canvas.width * INSERT_PCT.x;
    insertRect.y = canvas.height * INSERT_PCT.y;
    insertRect.w = canvas.width * INSERT_PCT.w;
    insertRect.h = canvas.height * INSERT_PCT.h;
  }

  function resetImagePosition() {
    if (!currentImg) return;
    var imgAspect = currentImg.naturalWidth / currentImg.naturalHeight;
    var insertAspect = insertRect.w / insertRect.h;
    if (imgAspect > insertAspect) {
      imgState.h = insertRect.h;
      imgState.w = insertRect.h * imgAspect;
    } else {
      imgState.w = insertRect.w;
      imgState.h = insertRect.w / imgAspect;
    }
    imgState.x = insertRect.x + (insertRect.w - imgState.w) / 2;
    imgState.y = insertRect.y + (insertRect.h - imgState.h) / 2;
  }

  function loadFrame() {
    if (!PRODUCT_IMAGE) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      frameImg = img;
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      computeInsertRect();
      draw();
    };
    img.src = PRODUCT_IMAGE;
  }

  // --- Quality check ---

  function checkImageQuality(img) {
    var cropScaleX = img.naturalWidth / imgState.w;
    var cropScaleY = img.naturalHeight / imgState.h;
    var cropW = insertRect.w * cropScaleX;
    var cropH = insertRect.h * cropScaleY;

    var ratio = Math.min(cropW / PRINT_WIDTH, cropH / PRINT_HEIGHT);
    qualityEl.hidden = false;

    if (ratio >= 0.5) {
      qualityEl.textContent = 'Image quality: Great for print (' + Math.round(cropW) + 'x' + Math.round(cropH) + 'px)';
      qualityEl.style.color = '#2e7d32';
    } else if (ratio >= 0.15) {
      qualityEl.textContent = 'Image quality: Good — a higher resolution image will print even sharper';
      qualityEl.style.color = '#e65100';
    } else {
      qualityEl.textContent = 'Warning: This image is very low resolution and may appear pixelated when printed';
      qualityEl.style.color = '#c62828';
    }
  }

  // --- Resize handles ---

  function getHandleSize() {
    var displayWidth = canvas.getBoundingClientRect().width || canvas.width;
    return Math.max(24, canvas.width / displayWidth * 20);
  }

  function getHandleCorners() {
    var s = getHandleSize();
    return [
      { x: insertRect.x - s / 2,                y: insertRect.y - s / 2 },
      { x: insertRect.x + insertRect.w - s / 2,  y: insertRect.y - s / 2 },
      { x: insertRect.x + insertRect.w - s / 2,  y: insertRect.y + insertRect.h - s / 2 },
      { x: insertRect.x - s / 2,                y: insertRect.y + insertRect.h - s / 2 },
    ];
  }

  function hitTestHandle(pos) {
    if (!currentImg) return -1;
    var corners = getHandleCorners();
    var s = getHandleSize();
    var hitPad = s * 0.75;
    for (var i = 0; i < corners.length; i++) {
      var cx = corners[i].x + s / 2;
      var cy = corners[i].y + s / 2;
      if (Math.abs(pos.x - cx) < s / 2 + hitPad && Math.abs(pos.y - cy) < s / 2 + hitPad) return i;
    }
    return -1;
  }

  function getRotateHandle() {
    var s = getHandleSize();
    var stemLen = s * 2.5;
    var cx = insertRect.x + insertRect.w / 2;
    var cy = insertRect.y - stemLen;
    return { x: cx, y: cy, stemTop: insertRect.y, radius: s * 0.7 };
  }

  function hitTestRotateHandle(pos) {
    if (!currentImg) return false;
    var rh = getRotateHandle();
    var dx = pos.x - rh.x;
    var dy = pos.y - rh.y;
    var hitRadius = rh.radius * 2; // generous hit area
    return (dx * dx + dy * dy) <= hitRadius * hitRadius;
  }

  function getAngleFromCenter(pos) {
    var cx = insertRect.x + insertRect.w / 2;
    var cy = insertRect.y + insertRect.h / 2;
    return Math.atan2(pos.x - cx, -(pos.y - cy)) * 180 / Math.PI;
  }

  function drawHandles() {
    if (!currentImg) return;
    var corners = getHandleCorners();
    var s = getHandleSize();
    ctx.save();
    for (var i = 0; i < corners.length; i++) {
      var c = corners[i];
      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
      ctx.strokeStyle = '#fae8ab';
      ctx.lineWidth = Math.max(2, canvas.width / 500);
      ctx.setLineDash([]);
      ctx.fillRect(c.x, c.y, s, s);
      ctx.strokeRect(c.x, c.y, s, s);
    }
    ctx.restore();

    // Rotation handle: stem line + circle above insert
    var rh = getRotateHandle();
    ctx.save();
    ctx.setLineDash([]);
    ctx.strokeStyle = '#fae8ab';
    ctx.lineWidth = Math.max(2, canvas.width / 500);
    ctx.beginPath();
    ctx.moveTo(rh.x, rh.stemTop);
    ctx.lineTo(rh.x, rh.y);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(rh.x, rh.y, rh.radius, 0, Math.PI * 2);
    ctx.fillStyle = '#365417';
    ctx.fill();
    ctx.strokeStyle = '#fae8ab';
    ctx.stroke();
    // Rotate icon (curved arrow) inside the circle
    ctx.beginPath();
    ctx.arc(rh.x, rh.y, rh.radius * 0.45, -Math.PI * 0.8, Math.PI * 0.4);
    ctx.strokeStyle = '#fae8ab';
    ctx.lineWidth = Math.max(2, canvas.width / 600);
    ctx.stroke();
    // Arrowhead
    var tipAngle = Math.PI * 0.4;
    var tipX = rh.x + Math.cos(tipAngle) * rh.radius * 0.45;
    var tipY = rh.y + Math.sin(tipAngle) * rh.radius * 0.45;
    var arrowLen = rh.radius * 0.3;
    ctx.beginPath();
    ctx.moveTo(tipX - arrowLen * 0.5, tipY - arrowLen);
    ctx.lineTo(tipX, tipY);
    ctx.lineTo(tipX + arrowLen, tipY - arrowLen * 0.3);
    ctx.strokeStyle = '#fae8ab';
    ctx.stroke();
    ctx.restore();
  }

  // --- Text layer helpers ---

  // Contrast outline: dark text gets a light halo and vice versa.
  function outlineColorFor(hex) {
    var c = hex.replace('#', '');
    var r = parseInt(c.slice(0, 2), 16) || 0;
    var g = parseInt(c.slice(2, 4), 16) || 0;
    var b = parseInt(c.slice(4, 6), 16) || 0;
    var lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return lum > 0.6 ? '#111111' : '#ffffff';
  }

  // Paint one text layer. Shared by the live preview and the print export so
  // they render identically — only the origin/unit box differs.
  function paintText(targetCtx, t, ox, oy, uw, uh) {
    var fontPx = Math.max(1, t.sizePct * uh);
    var tcx = ox + t.xPct * uw;
    var tcy = oy + t.yPct * uh;
    targetCtx.save();
    targetCtx.translate(tcx, tcy);
    targetCtx.rotate(t.rotation * Math.PI / 180);
    targetCtx.font = fontPx + 'px "' + t.fontFamily + '", sans-serif';
    targetCtx.textAlign = 'center';
    targetCtx.textBaseline = 'middle';
    var lines = t.text.split('\n');
    var lh = fontPx * 1.2;
    var startY = -((lines.length - 1) * lh) / 2;
    for (var i = 0; i < lines.length; i++) {
      var y = startY + i * lh;
      if (t.outline) {
        targetCtx.lineWidth = Math.max(1, fontPx * 0.14);
        targetCtx.strokeStyle = outlineColorFor(t.color);
        targetCtx.lineJoin = 'round';
        targetCtx.strokeText(lines[i], 0, y);
      }
      targetCtx.fillStyle = t.color;
      targetCtx.fillText(lines[i], 0, y);
    }
    targetCtx.restore();
  }

  // Text bounding box in canvas pixels (pre-rotation, centered at cx,cy).
  function textCanvasBox(t) {
    var fontPx = Math.max(1, t.sizePct * insertRect.h);
    var tcx = insertRect.x + t.xPct * insertRect.w;
    var tcy = insertRect.y + t.yPct * insertRect.h;
    ctx.save();
    ctx.font = fontPx + 'px "' + t.fontFamily + '", sans-serif';
    var lines = t.text.split('\n');
    var maxW = 0;
    for (var i = 0; i < lines.length; i++) {
      maxW = Math.max(maxW, ctx.measureText(lines[i] || ' ').width);
    }
    ctx.restore();
    var lh = fontPx * 1.2;
    return { cx: tcx, cy: tcy, w: maxW, h: Math.max(lh, lines.length * lh) };
  }

  function textHandleSize() {
    var displayWidth = canvas.getBoundingClientRect().width || canvas.width;
    return Math.max(26, canvas.width / displayWidth * 22); // slightly larger than image handles: touch-first
  }

  function hitTestText(pos) {
    for (var i = textLayers.length - 1; i >= 0; i--) { // topmost first
      var t = textLayers[i];
      var box = textCanvasBox(t);
      var a = -t.rotation * Math.PI / 180;
      var dx = pos.x - box.cx;
      var dy = pos.y - box.cy;
      var lx = dx * Math.cos(a) - dy * Math.sin(a);
      var ly = dx * Math.sin(a) + dy * Math.cos(a);
      var padX = box.w * 0.1 + 10;
      var padY = box.h * 0.2 + 10;
      if (Math.abs(lx) <= box.w / 2 + padX && Math.abs(ly) <= box.h / 2 + padY) return t;
    }
    return null;
  }

  function hitTestTextResizeHandle(t, pos) {
    var box = textCanvasBox(t);
    var hx = box.w / 2 + (box.w * 0.1 + 10);
    var hy = box.h / 2 + (box.h * 0.2 + 10);
    var a = -t.rotation * Math.PI / 180;
    var dx = pos.x - box.cx;
    var dy = pos.y - box.cy;
    var lx = dx * Math.cos(a) - dy * Math.sin(a);
    var ly = dx * Math.sin(a) + dy * Math.cos(a);
    var r = textHandleSize();
    return Math.abs(lx - hx) <= r && Math.abs(ly - hy) <= r;
  }

  function getSelectedTextLayer() {
    for (var i = 0; i < textLayers.length; i++) {
      if (textLayers[i].id === selectedTextId) return textLayers[i];
    }
    return null;
  }

  function drawTextLayers() {
    if (!textLayers.length) return;
    // Glyphs are clipped to the insert area so the preview matches the print
    // (the export only includes the insert crop).
    ctx.save();
    ctx.beginPath();
    ctx.rect(insertRect.x, insertRect.y, insertRect.w, insertRect.h);
    ctx.clip();
    for (var i = 0; i < textLayers.length; i++) {
      paintText(ctx, textLayers[i], insertRect.x, insertRect.y, insertRect.w, insertRect.h);
    }
    ctx.restore();

    var sel = getSelectedTextLayer();
    if (sel) {
      var box = textCanvasBox(sel);
      var padX = box.w * 0.1 + 10;
      var padY = box.h * 0.2 + 10;
      ctx.save();
      ctx.translate(box.cx, box.cy);
      ctx.rotate(sel.rotation * Math.PI / 180);
      ctx.setLineDash([10, 7]);
      ctx.strokeStyle = '#fae8ab';
      ctx.lineWidth = Math.max(2, canvas.width / 500);
      ctx.strokeRect(-box.w / 2 - padX, -box.h / 2 - padY, box.w + padX * 2, box.h + padY * 2);
      // Bottom-right resize handle
      var hs = textHandleSize();
      var hx = box.w / 2 + padX;
      var hy = box.h / 2 + padY;
      ctx.setLineDash([]);
      ctx.fillStyle = 'rgba(255,255,255,0.95)';
      ctx.strokeStyle = '#fae8ab';
      ctx.fillRect(hx - hs / 2, hy - hs / 2, hs, hs);
      ctx.strokeRect(hx - hs / 2, hy - hs / 2, hs, hs);
      ctx.restore();
    }
  }

  // --- Rotated image drawing helper ---

  function drawRotatedImg(targetCtx, x, y, w, h) {
    if (!currentImg) return;
    var cx = x + w / 2;
    var cy = y + h / 2;
    targetCtx.save();
    targetCtx.translate(cx, cy);
    targetCtx.rotate(rotation * Math.PI / 180);
    targetCtx.drawImage(currentImg, -w / 2, -h / 2, w, h);
    targetCtx.restore();
  }

  // --- Drawing ---

  // --- Frame visibility overlay (calibrated 2026-07 with the ruler insert):
  // the physical frame lip hides 0.75" of print on every side, and the
  // insert's bottom-left / bottom-right corners are cut off at 45°. The
  // visible area is drawn as a rectangle with those corners chamfered.
  var SIGN_LONG_SIDE_IN = 23.6267; // the insert maps to the 23.63" x 18" print
  // Drawn 25% thinner than the measured 0.75" overlap — visual preference so
  // the shaded band doesn't dominate the mock. Auto Fit still uses the full
  // 0.75" margin from the section setting.
  var FRAME_OVERLAP_IN = 0.5625;
  var CORNER_CUT_IN = 0.5; // 45° chamfer legs on the visible boundary

  function traceVisibleArea(o, c) {
    var x0 = insertRect.x, y0 = insertRect.y, w = insertRect.w, h = insertRect.h;
    ctx.moveTo(x0 + o, y0 + o);
    ctx.lineTo(x0 + w - o, y0 + o);
    ctx.lineTo(x0 + w - o, y0 + h - o - c);
    ctx.lineTo(x0 + w - o - c, y0 + h - o);
    ctx.lineTo(x0 + o + c, y0 + h - o);
    ctx.lineTo(x0 + o, y0 + h - o - c);
    ctx.closePath();
  }

  function drawFrameVisibilityOverlay() {
    if (!insertRect.w || !insertRect.h) return;
    var pxPerIn = insertRect.w / SIGN_LONG_SIDE_IN;
    var o = FRAME_OVERLAP_IN * pxPerIn; // hidden band
    var c = CORNER_CUT_IN * pxPerIn; // 45° bottom-corner chamfer

    ctx.save();
    // Hidden region: everything between the insert edge and the chamfered
    // visible area (even-odd fill: insert rect + visible hexagon as the hole).
    ctx.beginPath();
    ctx.rect(insertRect.x, insertRect.y, insertRect.w, insertRect.h);
    traceVisibleArea(o, c);
    ctx.fillStyle = 'rgba(15, 23, 42, 0.45)';
    ctx.fill('evenodd');

    // Boundary of what stays visible in the frame
    ctx.beginPath();
    traceVisibleArea(o, c);
    ctx.setLineDash([14, 10]);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
    ctx.lineWidth = Math.max(2, canvas.width / 600);
    ctx.stroke();
    ctx.restore();
  }

  // Decorate the "Review Your Design" image with the same frame-visibility
  // treatment: shade the 0.75" hidden band and the 45° bottom-corner cuts.
  // Display-only — the clean JPEG is what actually uploads on approve.
  function buildReviewPreview(croppedJpeg, done) {
    var img = new Image();
    img.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;
        var cx = c.getContext('2d');
        cx.drawImage(img, 0, 0);
        var pxPerIn = c.width / SIGN_LONG_SIDE_IN;
        var o = FRAME_OVERLAP_IN * pxPerIn;
        var cut = CORNER_CUT_IN * pxPerIn;
        var trace = function () {
          cx.moveTo(o, o);
          cx.lineTo(c.width - o, o);
          cx.lineTo(c.width - o, c.height - o - cut);
          cx.lineTo(c.width - o - cut, c.height - o);
          cx.lineTo(o + cut, c.height - o);
          cx.lineTo(o, c.height - o - cut);
          cx.closePath();
        };
        cx.beginPath();
        cx.rect(0, 0, c.width, c.height);
        trace();
        cx.fillStyle = 'rgba(15, 23, 42, 0.45)';
        cx.fill('evenodd');
        cx.beginPath();
        trace();
        cx.setLineDash([14, 10]);
        cx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
        cx.lineWidth = Math.max(2, c.width / 600);
        cx.stroke();
        done(c.toDataURL('image/jpeg', 0.9));
      } catch (err) {
        done(croppedJpeg); // fall back to the plain preview
      }
    };
    img.onerror = function () { done(croppedJpeg); };
    img.src = croppedJpeg;
  }

  function draw() {
    if (!frameImg) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(frameImg, 0, 0);
    if (currentImg) {
      ctx.globalAlpha = 0.25;
      drawRotatedImg(ctx, imgState.x, imgState.y, imgState.w, imgState.h);
      ctx.globalAlpha = 1.0;
      ctx.save();
      ctx.beginPath();
      ctx.rect(insertRect.x, insertRect.y, insertRect.w, insertRect.h);
      ctx.clip();
      drawRotatedImg(ctx, imgState.x, imgState.y, imgState.w, imgState.h);
      ctx.restore();
    }
    ctx.save();
    ctx.setLineDash([12, 8]);
    ctx.strokeStyle = '#fae8ab';
    ctx.lineWidth = Math.max(2, canvas.width / 400);
    ctx.strokeRect(insertRect.x, insertRect.y, insertRect.w, insertRect.h);
    ctx.restore();
    drawFrameVisibilityOverlay();
    drawHandles();
    drawTextLayers();
    if (currentImg) checkImageQuality(currentImg);
  }

  // --- Coordinate helpers ---

  function canvasCoords(e) {
    var rect = canvas.getBoundingClientRect();
    var sx = canvas.width / rect.width;
    var sy = canvas.height / rect.height;
    var cx, cy;
    if (e.touches) { cx = e.touches[0].clientX; cy = e.touches[0].clientY; }
    else { cx = e.clientX; cy = e.clientY; }
    return { x: (cx - rect.left) * sx, y: (cy - rect.top) * sy };
  }

  function getTouchDistance(e) {
    var t = e.touches;
    return Math.sqrt(Math.pow(t[0].clientX - t[1].clientX, 2) + Math.pow(t[0].clientY - t[1].clientY, 2));
  }

  // --- Pointer handlers ---

  function onDown(e) {
    if (e.touches && e.touches.length === 2) {
      pinchStartDist = getTouchDistance(e);
      // Pinch resizes the SELECTED TEXT when there is one (what customers
      // expect); otherwise it zooms the image as before.
      var selForPinch = getSelectedTextLayer();
      if (selForPinch) {
        pinchTextId = selForPinch.id;
        pinchTextStartSize = selForPinch.sizePct;
        e.preventDefault();
        return;
      }
      if (!currentImg) return;
      imgSnapshot = { x: imgState.x, y: imgState.y, w: imgState.w, h: imgState.h };
      e.preventDefault();
      return;
    }
    var pos = canvasCoords(e);

    // Resize handle of the already-selected text (top priority).
    var selText = getSelectedTextLayer();
    if (selText && hitTestTextResizeHandle(selText, pos)) {
      resizingTextId = selText.id;
      var selBox = textCanvasBox(selText);
      textResizeStart = {
        dist: Math.max(1, Math.sqrt(Math.pow(pos.x - selBox.cx, 2) + Math.pow(pos.y - selBox.cy, 2))),
        sizePct: selText.sizePct,
      };
      e.preventDefault();
      return;
    }

    // Text layers next: tap to select, drag to move.
    var hitT = hitTestText(pos);
    if (hitT) {
      selectText(hitT.id);
      draggingTextId = hitT.id;
      textDragStart = pos;
      textSnapshot = { xPct: hitT.xPct, yPct: hitT.yPct };
      draw();
      e.preventDefault();
      return;
    }
    // Tapped off any text: on touch, deselect (closes the panel and restores
    // the controls). On desktop the panel STAYS open — the right column
    // shouldn't flicker in and out with every canvas click; Done closes it.
    if (selectedTextId !== null && window.matchMedia('(pointer: coarse)').matches) {
      selectText(null);
      draw();
    }

    if (!currentImg) return;
    imgSnapshot = { x: imgState.x, y: imgState.y, w: imgState.w, h: imgState.h };

    // Check rotation handle first
    if (hitTestRotateHandle(pos)) {
      rotating = true;
      dragging = false;
      resizing = false;
      rotateStartAngle = getAngleFromCenter(pos);
      rotateStartRotation = rotation;
      canvas.style.cursor = 'grabbing';
      e.preventDefault();
      return;
    }

    if (hitTestHandle(pos) >= 0) {
      resizing = true;
      dragging = false;
      var cx = insertRect.x + insertRect.w / 2;
      var cy = insertRect.y + insertRect.h / 2;
      resizeStartDist = Math.sqrt(Math.pow(pos.x - cx, 2) + Math.pow(pos.y - cy, 2));
      e.preventDefault();
      return;
    }
    dragging = true;
    pointerStart = pos;
    canvas.style.cursor = 'grabbing';
    e.preventDefault();
  }

  function onMove(e) {
    if (e.touches && e.touches.length === 2 && pinchTextId) {
      var tp = null;
      for (var ti = 0; ti < textLayers.length; ti++) {
        if (textLayers[ti].id === pinchTextId) { tp = textLayers[ti]; break; }
      }
      if (tp) {
        var pinchRatio = getTouchDistance(e) / pinchStartDist;
        tp.sizePct = Math.max(0.04, Math.min(0.5, pinchTextStartSize * pinchRatio));
        syncTextPanel();
        draw();
      }
      e.preventDefault();
      return;
    }
    if (resizingTextId) {
      var tr = null;
      for (var tj = 0; tj < textLayers.length; tj++) {
        if (textLayers[tj].id === resizingTextId) { tr = textLayers[tj]; break; }
      }
      if (tr) {
        var rpos = canvasCoords(e);
        var rbox = textCanvasBox(tr); // center stays fixed while resizing
        var rd = Math.sqrt(Math.pow(rpos.x - rbox.cx, 2) + Math.pow(rpos.y - rbox.cy, 2));
        tr.sizePct = Math.max(0.04, Math.min(0.5, textResizeStart.sizePct * (rd / textResizeStart.dist)));
        syncTextPanel();
        draw();
      }
      e.preventDefault();
      return;
    }
    if (draggingTextId) {
      var td = null;
      for (var tk = 0; tk < textLayers.length; tk++) {
        if (textLayers[tk].id === draggingTextId) { td = textLayers[tk]; break; }
      }
      if (td && insertRect.w && insertRect.h) {
        var dpos = canvasCoords(e);
        td.xPct = Math.max(0, Math.min(1, textSnapshot.xPct + (dpos.x - textDragStart.x) / insertRect.w));
        td.yPct = Math.max(0, Math.min(1, textSnapshot.yPct + (dpos.y - textDragStart.y) / insertRect.h));
        draw();
      }
      e.preventDefault();
      return;
    }
    if (!currentImg) return;
    if (e.touches && e.touches.length === 2) {
      var dist = getTouchDistance(e);
      var ratio = dist / pinchStartDist;
      var cx = insertRect.x + insertRect.w / 2;
      var cy = insertRect.y + insertRect.h / 2;
      imgState.w = imgSnapshot.w * ratio;
      imgState.h = imgSnapshot.h * ratio;
      imgState.x = cx - (cx - imgSnapshot.x) * ratio;
      imgState.y = cy - (cy - imgSnapshot.y) * ratio;
      draw();
      e.preventDefault();
      return;
    }
    if (rotating) {
      var pos = canvasCoords(e);
      var currentAngle = getAngleFromCenter(pos);
      rotation = rotateStartRotation + (currentAngle - rotateStartAngle);
      // Snap to 0/90/180/-90 when within 3 degrees
      var snapAngles = [0, 90, 180, -180, -90];
      for (var s = 0; s < snapAngles.length; s++) {
        if (Math.abs(rotation - snapAngles[s]) < 3) { rotation = snapAngles[s]; break; }
      }
      draw();
      e.preventDefault();
      return;
    }
    if (resizing) {
      var pos = canvasCoords(e);
      var cx = insertRect.x + insertRect.w / 2;
      var cy = insertRect.y + insertRect.h / 2;
      var currentDist = Math.sqrt(Math.pow(pos.x - cx, 2) + Math.pow(pos.y - cy, 2));
      var ratio = Math.max(0.3, Math.min(currentDist / resizeStartDist, 3.0));
      imgState.w = imgSnapshot.w * ratio;
      imgState.h = imgSnapshot.h * ratio;
      imgState.x = cx - (cx - imgSnapshot.x) * ratio;
      imgState.y = cy - (cy - imgSnapshot.y) * ratio;
      draw();
      e.preventDefault();
      return;
    }
    if (!dragging) return;
    var pos = canvasCoords(e);
    imgState.x = imgSnapshot.x + (pos.x - pointerStart.x);
    imgState.y = imgSnapshot.y + (pos.y - pointerStart.y);
    draw();
    e.preventDefault();
  }

  function onUp() {
    dragging = false;
    resizing = false;
    rotating = false;
    draggingTextId = null;
    resizingTextId = null;
    pinchTextId = null;
    canvas.style.cursor = currentImg ? 'grab' : 'default';
  }

  canvas.addEventListener('mousedown', onDown);
  canvas.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
  canvas.addEventListener('touchstart', onDown, { passive: false });
  canvas.addEventListener('touchmove', onMove, { passive: false });
  window.addEventListener('touchend', onUp);

  canvas.addEventListener('wheel', function (e) {
    if (!currentImg) return;
    e.preventDefault();
    var f = e.deltaY < 0 ? 1.05 : 0.95;
    var cx = insertRect.x + insertRect.w / 2;
    var cy = insertRect.y + insertRect.h / 2;
    imgState.w *= f;
    imgState.h *= f;
    imgState.x = cx - (cx - imgState.x) * f;
    imgState.y = cy - (cy - imgState.y) * f;
    draw();
  }, { passive: false });

  canvas.addEventListener('mousemove', function (e) {
    if (!currentImg || dragging || resizing || rotating) return;
    var pos = canvasCoords(e);
    if (hitTestRotateHandle(pos)) {
      canvas.style.cursor = 'crosshair';
    } else if (hitTestHandle(pos) >= 0) {
      canvas.style.cursor = 'nwse-resize';
    } else {
      canvas.style.cursor = 'grab';
    }
  });

  if (resetBtn) {
    // Start Over: clear the image and all text, back to the empty frame with
    // the glowing "Select Your Image" overlay.
    resetBtn.addEventListener('click', function () {
      currentImg = null;
      fitSourceImg = null;
      rotation = 0;
      textLayers.length = 0;
      selectText(null);
      container.classList.remove('ai-design-generator--has-image');
      fileInput.value = '';
      qualityEl.hidden = true;
      hideError();
      resetBtn.hidden = true;
      if (aifitBtn) aifitBtn.hidden = true;
      if (aifitNote) aifitNote.hidden = true;
      if (addTextBtn) addTextBtn.hidden = true;
      if (editImgBtn) editImgBtn.hidden = true;
      if (hintEl) hintEl.hidden = true;
      setAddToCartEnabled(false);
      draw();
    });
  }

  // --- File upload ---

  // --- Image loading with auto-resize for phone photos ---
  var MAX_SOURCE_PX = 5400; // cap source at print resolution to save memory

  function resizeImageIfNeeded(img) {
    var w = img.naturalWidth;
    var h = img.naturalHeight;
    if (w <= MAX_SOURCE_PX && h <= MAX_SOURCE_PX) return img;
    // Downscale to fit within MAX_SOURCE_PX on longest side
    var scale = MAX_SOURCE_PX / Math.max(w, h);
    var nw = Math.round(w * scale);
    var nh = Math.round(h * scale);
    var c = document.createElement('canvas');
    c.width = nw;
    c.height = nh;
    c.getContext('2d').drawImage(img, 0, 0, nw, nh);
    var resized = new Image();
    resized.src = c.toDataURL('image/jpeg', 0.92);
    return resized;
  }

  function loadImageFromFile(file) {
    return new Promise(function (resolve, reject) {
      // Use createObjectURL for better memory handling with large files
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        // Resize if needed to save memory on phones
        var final = resizeImageIfNeeded(img);
        if (final === img) {
          resolve(img);
        } else {
          // Wait for resized image to load
          final.onload = function () { resolve(final); };
          final.onerror = function () { resolve(img); }; // fallback to original
        }
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('Could not read this image file.'));
      };
      img.src = url;
    });
  }

  fileInput.addEventListener('change', function () {
    var file = fileInput.files[0];
    if (!file) return;

    // Accept any image type — the browser handles decoding (including HEIC on iOS/Mac)
    if (!file.type.match(/^image\//)) {
      showError('Please select an image file.');
      return;
    }

    // Validate size (max 50MB raw — we resize before upload)
    if (file.size > 50 * 1024 * 1024) {
      showError('Image too large. Please select a smaller image.');
      return;
    }

    hideError();

    loadImageFromFile(file).then(function (img) {
      currentImg = img;
      fitSourceImg = img;
      rotation = 0;
      resetImagePosition();
      draw();
      showControls();
    }).catch(function (err) {
      showError(err.message || 'Could not read image. Please try a different file.');
    });
  });

  // --- Crop extraction ---

  function extractCroppedImage() {
    // Extract at the SOURCE image's native resolution, not the canvas display resolution.
    // This preserves maximum quality for the print pipeline.
    var natW = currentImg.naturalWidth;
    var natH = currentImg.naturalHeight;

    // Scale factor: how many source pixels per canvas pixel
    var scaleX = natW / imgState.w;
    var scaleY = natH / imgState.h;

    // The insert rect in source-image coordinate space
    var cropW = Math.round(insertRect.w * scaleX);
    var cropH = Math.round(insertRect.h * scaleY);

    // Cap at print resolution — backend upscales to 5400x7088 anyway,
    // sending more just bloats the upload and can hit Nginx limits.
    var MAX_CROP = 5400;
    if (cropW > MAX_CROP || cropH > MAX_CROP) {
      var downscale = MAX_CROP / Math.max(cropW, cropH);
      scaleX *= downscale;
      scaleY *= downscale;
      cropW = Math.round(cropW * downscale);
      cropH = Math.round(cropH * downscale);
    }

    // Render the rotated source image at full native resolution onto a large offscreen canvas,
    // positioned so the insert area maps to the same relative location.
    var bigW = Math.round(canvas.width * scaleX);
    var bigH = Math.round(canvas.height * scaleY);
    var bigImgX = Math.round(imgState.x * scaleX);
    var bigImgY = Math.round(imgState.y * scaleY);
    var bigInsertX = Math.round(insertRect.x * scaleX);
    var bigInsertY = Math.round(insertRect.y * scaleY);

    var offscreen = document.createElement('canvas');
    offscreen.width = bigW;
    offscreen.height = bigH;
    var offCtx = offscreen.getContext('2d');

    // Draw rotated image at native resolution
    var cx = bigImgX + natW / 2;
    var cy = bigImgY + natH / 2;
    offCtx.save();
    offCtx.translate(cx, cy);
    offCtx.rotate(rotation * Math.PI / 180);
    offCtx.drawImage(currentImg, -natW / 2, -natH / 2, natW, natH);
    offCtx.restore();

    // Crop the insert area
    var cropCanvas = document.createElement('canvas');
    cropCanvas.width = cropW;
    cropCanvas.height = cropH;
    var cropCtx = cropCanvas.getContext('2d');
    cropCtx.drawImage(offscreen, bigInsertX, bigInsertY, cropW, cropH, 0, 0, cropW, cropH);
    // Composite text layers at crop resolution — vector glyphs stay razor-sharp
    // in the print file. Same painter as the live preview.
    for (var t = 0; t < textLayers.length; t++) {
      paintText(cropCtx, textLayers[t], 0, 0, cropW, cropH);
    }
    return cropCanvas.toDataURL('image/jpeg', 0.92);
  }

  // --- Add to Cart intercept ---

  function getAddToCartBtn() {
    return document.querySelector('[data-main-product-add-to-cart], product-form button[type="submit"]');
  }

  // The upload-design template renders the add-to-cart button server-side `disabled`
  // (the real HTML attribute, not just the greyed class) so a tap can't beat this
  // script to checkout. A fast tap on a slow mobile load was letting the bare product
  // reach fulfillment with no design attached (order #18699). We re-enable it only once
  // a design has actually been loaded and positioned. The sticky bar just proxies
  // .click() to this same button, so gating this one covers both surfaces.
  function setAddToCartEnabled(enabled) {
    document.querySelectorAll('[data-main-product-add-to-cart][data-requires-design]').forEach(function (b) {
      b.disabled = !enabled;
      b.classList.toggle('disabled', !enabled);
    });
  }

  var _approved = false;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-main-product-add-to-cart], product-form button[type="submit"]');
    if (!btn) return;
    if (_approved) return;

    if (!currentImg) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError('Please select and position your image below before adding to cart.');
      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    try {
      var croppedJpeg = extractCroppedImage();
      previewImg.src = croppedJpeg;
      if (previewCheckbox) previewCheckbox.checked = false;
      if (previewApprove) previewApprove.disabled = true;
      previewModal.hidden = false;
      previewModal._croppedJpeg = croppedJpeg;
      // Swap in the frame-visibility version (hidden band + corner cuts)
      buildReviewPreview(croppedJpeg, function (decorated) { previewImg.src = decorated; });
    } catch (err) {
      showError('Could not extract design. Try uploading again.');
    }
  }, true);

  // --- Background detection: composite onto white (transparent areas print
  // white) and take the MEDIAN colour of a thin border band. The median ignores
  // a bit of artwork touching an edge, so we always get the dominant background
  // colour to pad with — a single flat colour that matches, never an averaged or
  // generative-fill "rainbow". currentImg is always same-origin (user file or
  // our own data URI), so getImageData won't taint. ---

  function median(arr) {
    arr.sort(function (a, b) { return a - b; });
    return arr[Math.floor(arr.length / 2)];
  }

  function detectBackgroundColor(img) {
    var SAMPLE = 200; // small copy keeps the per-pixel scan cheap
    var scale = Math.min(1, SAMPLE / Math.max(img.naturalWidth, img.naturalHeight));
    var sw = Math.max(2, Math.round(img.naturalWidth * scale));
    var sh = Math.max(2, Math.round(img.naturalHeight * scale));
    var c = document.createElement('canvas');
    c.width = sw; c.height = sh;
    var cx = c.getContext('2d');
    cx.fillStyle = '#ffffff';
    cx.fillRect(0, 0, sw, sh);
    cx.drawImage(img, 0, 0, sw, sh);
    var data = cx.getImageData(0, 0, sw, sh).data;

    var band = Math.max(1, Math.round(Math.min(sw, sh) * 0.05)); // ~5% border band
    var rs = [], gs = [], bs = [];
    for (var y = 0; y < sh; y++) {
      for (var x = 0; x < sw; x++) {
        if (x >= band && x < sw - band && y >= band && y < sh - band) continue;
        var i = (y * sw + x) * 4;
        rs.push(data[i]); gs.push(data[i + 1]); bs.push(data[i + 2]);
      }
    }
    return [median(rs), median(gs), median(bs)];
  }

  // --- Deterministic fit: contain the design inside the sign aspect with a
  // margin on all sides, then fill the surrounding area with the detected
  // background color so the design never runs to the edge. The margin is set
  // in inches of physical sign (default 0.75" = the measured frame overlap,
  // so the design edge lands at the frame's visible boundary) and converted
  // to a fraction of the sign's 18" short side; the padded canvas matches the
  // insert aspect, so it loads back and fills the insert with its margin
  // intact. ---

  var SIGN_SHORT_SIDE_IN = 18; // printed sign is 23.63" x 18"
  var fitMarginInches = parseFloat(container.dataset.fitMargin);
  if (isNaN(fitMarginInches)) fitMarginInches = 0.75;
  var FIT_MARGIN = fitMarginInches / SIGN_SHORT_SIDE_IN;

  function buildPaddedFit(srcImg, bgColor) {
    var W0 = srcImg.naturalWidth, H0 = srcImg.naturalHeight;
    var A = (insertRect.w && insertRect.h) ? insertRect.w / insertRect.h
                                           : PRINT_WIDTH / PRINT_HEIGHT;
    var g = Math.min(FIT_MARGIN, 0.45); // margin as a fraction of the short side
    var R0 = W0 / H0;
    var insetAspect = (A - 2 * g) / (1 - 2 * g);

    // Size the canvas so the design sits at native resolution inside the inset
    // (the design is never upscaled — only padded around).
    var canvasH = (R0 > insetAspect) ? W0 / (A - 2 * g) : H0 / (1 - 2 * g);
    var canvasW = canvasH * A;

    // Cap to print resolution to bound memory on phones.
    var MAX = 5400;
    var capScale = Math.min(1, MAX / Math.max(canvasW, canvasH));
    canvasW = Math.round(canvasW * capScale);
    canvasH = Math.round(canvasH * capScale);

    var marginPx = g * canvasH; // equal absolute margin on all four sides
    var insetW = canvasW - 2 * marginPx;
    var insetH = canvasH - 2 * marginPx;
    var s = Math.min(insetW / W0, insetH / H0);
    var drawnW = W0 * s, drawnH = H0 * s;

    var c = document.createElement('canvas');
    c.width = canvasW; c.height = canvasH;
    var cx = c.getContext('2d');
    cx.fillStyle = 'rgb(' + bgColor[0] + ',' + bgColor[1] + ',' + bgColor[2] + ')';
    cx.fillRect(0, 0, canvasW, canvasH);
    cx.drawImage(srcImg, (canvasW - drawnW) / 2, (canvasH - drawnH) / 2, drawnW, drawnH);
    // PNG keeps text crisp and flat padding compresses tiny; the final
    // add-to-cart export re-encodes to JPEG anyway.
    return c.toDataURL('image/png');
  }

  // Load a result image (padded fit or AI outpaint) back as the editable image.
  function loadResultImage(dataUri, errMsg) {
    var img = new Image();
    img.onload = function () {
      currentImg = img;
      rotation = 0;
      resetImagePosition();
      draw();
      showControls();
    };
    img.onerror = function () { showError(errMsg); };
    img.src = dataUri;
  }

  if (aifitBtn) {
    aifitBtn.addEventListener('click', function () {
      if (!currentImg || uploadInProgress) return;
      uploadInProgress = true;
      hideError();
      var origText = aifitBtn.textContent;
      aifitBtn.disabled = true;
      aifitBtn.textContent = 'Fitting your image…';
      try {
        // Pad with the design's dominant background colour — a single flat colour
        // that matches the edges, for any image (no AI call, so no "rainbow").
        // Always fit from the ORIGINAL image so repeated clicks don't re-pad
        // the already-padded result (which shrank the design every click).
        var fitSrc = fitSourceImg || currentImg;
        loadResultImage(buildPaddedFit(fitSrc, detectBackgroundColor(fitSrc)),
          'Could not fit your image. Please try again.');
      } catch (err) {
        showError('Fit failed: ' + (err.message || 'please try again'));
      } finally {
        uploadInProgress = false;
        aifitBtn.disabled = false;
        aifitBtn.textContent = origText;
      }
    });
  }

  if (previewApprove) {
    previewApprove.addEventListener('click', async function () {
      if (uploadInProgress) return;
      uploadInProgress = true;
      previewApprove.disabled = true;
      previewApprove.textContent = 'Uploading\u2026';

      try {
        var croppedJpeg = previewModal._croppedJpeg;

        previewApprove.textContent = 'Checking image\u2026';
        var res = await fetch(API_ENDPOINT + '/upload-design', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY },
          body: JSON.stringify({ imageData: croppedJpeg }),
        });
        var data = await res.json();
        if (data.rejected) {
          // Trademark detected — show rejection in the proof modal itself
          previewApprove.hidden = true;
          previewCheckbox.closest('label').hidden = true;
          previewImg.style.border = '3px solid #c62828';

          var rejectionMsg = document.getElementById('upload-rejection-msg');
          if (!rejectionMsg) {
            rejectionMsg = document.createElement('div');
            rejectionMsg.id = 'upload-rejection-msg';
            rejectionMsg.style.cssText = 'background:#c62828;color:#fff;padding:16px;border-radius:10px;margin-top:12px;text-align:center;font-size:15px;line-height:1.5;';
            previewCancel.parentNode.insertBefore(rejectionMsg, previewCancel);
          }
          rejectionMsg.innerHTML = '<strong style="font-size:17px;">Upload Blocked</strong><br><br>' +
            (data.error || 'This image contains trademarked content and cannot be printed.') +
            '<br><br><a href="/pages/contact" style="color:#fae8ab;font-weight:600;">Contact Us</a> if you believe this is a mistake.';
          previewCancel.textContent = 'Try a Different Image';
          return;
        }
        if (!res.ok) throw new Error(data.error || 'Upload failed');

        // Inject hidden fields — same keys as AI design so fulfillment works unchanged
        var formEl = document.querySelector('product-form form');
        if (formEl) {
          formEl.querySelectorAll('input[name^="properties[_ai-design"]').forEach(function (el) { el.remove(); });

          var inputProd = document.createElement('input');
          inputProd.type = 'hidden';
          inputProd.name = 'properties[_ai-design-production-url]';
          inputProd.value = data.productionUrl;
          formEl.appendChild(inputProd);

          var inputPreview = document.createElement('input');
          inputPreview.type = 'hidden';
          inputPreview.name = 'properties[_ai-design-preview]';
          inputPreview.value = data.previewUrl;
          formEl.appendChild(inputPreview);
        }

        previewModal.hidden = true;
        _approved = true;
        var realBtn = getAddToCartBtn();
        // Make sure our own gate isn't what blocks this programmatic submit.
        if (realBtn) { realBtn.disabled = false; realBtn.click(); }
        setTimeout(function () { _approved = false; }, 500);
      } catch (err) {
        showError('Upload failed: ' + err.message);
        previewModal.hidden = true;
      } finally {
        uploadInProgress = false;
        previewApprove.disabled = false;
        previewApprove.textContent = 'Add to Cart';
      }
    });
  }

  if (previewCancel) {
    previewCancel.addEventListener('click', function () {
      previewModal.hidden = true;
      // Reset modal state in case it was a rejection
      previewApprove.hidden = false;
      previewApprove.disabled = true;
      previewApprove.textContent = 'Add to Cart';
      if (previewCheckbox) {
        previewCheckbox.checked = false;
        previewCheckbox.closest('label').hidden = false;
      }
      if (previewImg) previewImg.style.border = '';
      var rejMsg = document.getElementById('upload-rejection-msg');
      if (rejMsg) rejMsg.remove();
      previewCancel.textContent = 'Go Back';
    });
  }

  // X button closes the preview via the same reset path as cancel
  var previewClose = document.getElementById('upload-preview-close');
  if (previewClose && previewCancel) {
    previewClose.addEventListener('click', function () {
      if (uploadInProgress) return;
      previewCancel.click();
    });
  }

  if (previewCheckbox && previewApprove) {
    previewCheckbox.addEventListener('change', function () {
      previewApprove.disabled = !previewCheckbox.checked;
    });
  }

  // --- Text panel wiring ---

  var addTextBtn = document.getElementById('upload-addtext-btn');
  var textPanel = document.getElementById('upload-text-panel');
  var textInput = document.getElementById('upload-text-input');
  var textFontsEl = document.getElementById('upload-text-fonts');
  var textRotationEl = document.getElementById('upload-text-rotation');
  var textColorsEl = document.getElementById('upload-text-colors');
  var textColorCustom = document.getElementById('upload-text-color-custom');
  var textOutlineEl = document.getElementById('upload-text-outline');
  var textDeleteBtn = document.getElementById('upload-text-delete');
  var textDoneBtn = document.getElementById('upload-text-done');

  var TEXT_SWATCHES = ['#ffffff', '#000000', '#e11d48', '#2563eb', '#16a34a', '#f59e0b'];

  // Build the font chip strip once — each chip previews its own typeface.
  if (textFontsEl) {
    TEXT_FONTS.forEach(function (fam) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'upload-text__font-chip';
      chip.textContent = fam;
      chip.dataset.font = fam;
      chip.style.fontFamily = '"' + fam + '", sans-serif';
      chip.addEventListener('click', function () {
        var sel = getSelectedTextLayer();
        if (!sel) return;
        sel.fontFamily = fam;
        syncTextPanel();
        if (document.fonts) document.fonts.load('64px "' + fam + '"').then(draw).catch(function () {});
        draw();
      });
      textFontsEl.appendChild(chip);
    });
  }

  // Build the color swatches once.
  if (textColorsEl) {
    TEXT_SWATCHES.forEach(function (col) {
      var sw = document.createElement('button');
      sw.type = 'button';
      sw.className = 'upload-text__swatch';
      sw.dataset.color = col;
      sw.style.backgroundColor = col;
      sw.setAttribute('aria-label', 'Text color ' + col);
      sw.addEventListener('click', function () {
        var sel = getSelectedTextLayer();
        if (!sel) return;
        sel.color = col;
        syncTextPanel();
        draw();
      });
      textColorsEl.appendChild(sw);
    });
  }

  function selectText(id, opts) {
    selectedTextId = id;
    if (!textPanel) return;
    if (id === null) {
      textPanel.hidden = true;
      // Un-pin the sign preview when editing ends.
      container.classList.remove('ai-design-generator--text-editing');
      return;
    }
    textPanel.hidden = false;
    // Edit mode: hides the in-between controls so the panel sits right under
    // (mobile) or beside (desktop) the sign.
    container.classList.add('ai-design-generator--text-editing');
    syncTextPanel();
    var touchDevice = window.matchMedia('(pointer: coarse)').matches;
    if (opts && opts.focus && textInput && !touchDevice) {
      // Desktop: focus so typing updates the sign immediately. (Skipped on
      // touch — auto-popping the keyboard while the layout is settling is
      // jarring; the input select-all on focus covers them when they tap it.)
      textInput.focus();
      textInput.select();
    } else if (opts && opts.focus && touchDevice) {
      // Mobile: frame the edit screen — sign at the top, panel below.
      // VERTICAL-ONLY window scroll: scrollIntoView also scrolls horizontal
      // ancestors (the gallery container), which shoved the page sideways.
      requestAnimationFrame(function () {
        var top = canvas.getBoundingClientRect().top + window.scrollY - 8;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }
  }

  // Reflect the selected layer into the panel controls (also called while the
  // corner handle / pinch resizes, so the size slider tracks live).
  function syncTextPanel() {
    var sel = getSelectedTextLayer();
    if (!sel || !textPanel) return;
    if (textInput && textInput.value !== sel.text) textInput.value = sel.text;
    if (textRotationEl) textRotationEl.value = Math.round(sel.rotation);
    if (textOutlineEl) textOutlineEl.checked = sel.outline;
    if (textColorCustom) textColorCustom.value = sel.color;
    if (textFontsEl) {
      Array.prototype.forEach.call(textFontsEl.children, function (chip) {
        chip.classList.toggle('is-active', chip.dataset.font === sel.fontFamily);
      });
    }
    if (textColorsEl) {
      Array.prototype.forEach.call(textColorsEl.children, function (sw) {
        sw.classList.toggle('is-active', sw.dataset.color === sel.color);
      });
    }
  }

  if (addTextBtn) {
    addTextBtn.addEventListener('click', function () {
      ensureTextFonts();
      textIdSeq++;
      var layer = {
        id: 't' + textIdSeq,
        text: 'Your text',
        xPct: 0.5,
        yPct: 0.5,
        sizePct: 0.16,
        rotation: 0,
        fontFamily: DEFAULT_TEXT_FONT,
        color: '#ffffff',
        outline: true,
      };
      textLayers.push(layer);
      selectText(layer.id, { focus: true });
      if (document.fonts) document.fonts.load('64px "' + layer.fontFamily + '"').then(draw).catch(function () {});
      draw();
    });
  }

  if (textInput) {
    textInput.addEventListener('input', function () {
      var sel = getSelectedTextLayer();
      if (!sel) return;
      sel.text = textInput.value;
      draw();
    });
    // Select-all on focus so typing replaces the placeholder in one go —
    // this is how touch users overwrite "Your text" without fiddling.
    textInput.addEventListener('focus', function () {
      textInput.select();
    });
  }
  if (textRotationEl) {
    textRotationEl.addEventListener('input', function () {
      var sel = getSelectedTextLayer();
      if (!sel) return;
      sel.rotation = Number(textRotationEl.value);
      draw();
    });
  }
  if (textColorCustom) {
    textColorCustom.addEventListener('input', function () {
      var sel = getSelectedTextLayer();
      if (!sel) return;
      sel.color = textColorCustom.value;
      syncTextPanel();
      draw();
    });
  }
  if (textOutlineEl) {
    textOutlineEl.addEventListener('change', function () {
      var sel = getSelectedTextLayer();
      if (!sel) return;
      sel.outline = textOutlineEl.checked;
      draw();
    });
  }
  if (textDeleteBtn) {
    textDeleteBtn.addEventListener('click', function () {
      for (var i = 0; i < textLayers.length; i++) {
        if (textLayers[i].id === selectedTextId) { textLayers.splice(i, 1); break; }
      }
      selectText(null);
      draw();
    });
  }
  if (textDoneBtn) {
    textDoneBtn.addEventListener('click', function () {
      selectText(null); // closes the panel, restores the normal controls
      draw(); // clear the selection outline
    });
  }

  // ==========================================================================
  // Advanced image editor — full-screen pop-out (Crop + Change a Color + undo).
  // Operates on the ORIGINAL uploaded image at a capped working resolution;
  // Save flattens the result back into the sign flow as if freshly uploaded,
  // so moderation / upload / fulfillment are untouched.
  // ==========================================================================

  var editImgBtn = document.getElementById('upload-editimg-btn');
  var edOverlay = document.getElementById('upload-editor-overlay');
  var edCanvas = document.getElementById('upload-editor-canvas');
  var edUndoBtn = document.getElementById('ed-undo');
  var edRedoBtn = document.getElementById('ed-redo');
  var edResetBtn = document.getElementById('ed-reset');
  var edCancelBtn = document.getElementById('ed-cancel');
  var edApplyBtn = document.getElementById('ed-apply');
  var edToolCrop = document.getElementById('ed-tool-crop');
  var edToolColor = document.getElementById('ed-tool-color');
  var edHint = document.getElementById('ed-hint');
  var edCropBar = document.getElementById('ed-crop-bar');
  var edCropApply = document.getElementById('ed-crop-apply');
  var edCropCancel = document.getElementById('ed-crop-cancel');
  var edColorBar = document.getElementById('ed-color-bar');
  var edColorFrom = document.getElementById('ed-color-from');
  var edColorSwatches = document.getElementById('ed-color-swatches');
  var edColorCustom = document.getElementById('ed-color-custom');
  var edToolSelect = document.getElementById('ed-tool-select');
  var edSelBar = document.getElementById('ed-select-bar');
  var edSelMove = document.getElementById('ed-sel-move');
  var edSelDelete = document.getElementById('ed-sel-delete');
  var edSelCancel = document.getElementById('ed-sel-cancel');
  var edPieceBar = document.getElementById('ed-piece-bar');
  var edPiecePlace = document.getElementById('ed-piece-place');
  var edPieceCancel = document.getElementById('ed-piece-cancel');

  // --- Select a Part state (one floating piece at a time; flatten on place) ---
  var edSelRect = null;          // {x,y,w,h} current selection
  var edSelDrawing = false;      // drawing the initial box
  var edSelDrag = null;          // adjusting the box (corner index | 'move')
  var edBaseCanvas = null;       // offscreen copy of the base pixels for overlay redraws
  var edPiece = null;            // {canvas,x,y,w,h} floating piece
  var edPieceDrag = null;        // {kind:'move'|'scale', ...}
  var edPieceRestoreUri = null;  // pre-Move state for "Undo Move"
  var edTextNote = document.getElementById('ed-text-note');
  var edScopeSpot = document.getElementById('ed-scope-spot');
  var edScopeAll = document.getElementById('ed-scope-all');
  var edColorScope = 'spot';   // 'spot' (paint-bucket flood) | 'everywhere' (global)
  var edPickedXY = null;       // tap position — the flood seed
  var edLastHex = null;        // re-apply on scope toggle
  // What the editor opened with — lets Save preserve the sign placement when
  // the image dimensions didn't change (so text stays aligned over it).
  var edOpenedSource = null;
  var edOpenedW = 0;
  var edOpenedH = 0;

  var ED_MAX_PX = 2800; // working-resolution cap (ImageData memory on phones)
  var ED_SWATCHES = ['#ffffff', '#000000', '#e11d48', '#2563eb', '#16a34a', '#f59e0b', '#7c3aed', '#0d9488'];

  var edCtx = edCanvas ? edCanvas.getContext('2d') : null;
  var edMode = null;            // null | 'crop' | 'color'
  var edUndoStack = [];         // data URLs (compressed) — capped
  var edRedoStack = [];
  var edOriginalUri = null;     // for Reset
  var edPickedRGB = null;       // [r,g,b] target for Change a Color
  var edColorBaseData = null;   // ImageData snapshot before a replacement preview
  var edCrop = { x: 0, y: 0, w: 0, h: 0 };
  var edCropDrag = null;        // { kind: 'move'|corner index, startX, startY, snapshot }

  function edSetHint(t) { if (edHint) edHint.textContent = t; }

  function edUpdateHistoryButtons() {
    if (edUndoBtn) edUndoBtn.disabled = edUndoStack.length === 0;
    if (edRedoBtn) edRedoBtn.disabled = edRedoStack.length === 0;
    if (edResetBtn) edResetBtn.disabled = edUndoStack.length === 0 && edRedoStack.length === 0;
  }

  function edPushUndo() {
    edUndoStack.push(edCanvas.toDataURL('image/png'));
    if (edUndoStack.length > 10) edUndoStack.shift();
    edRedoStack.length = 0;
    edUpdateHistoryButtons();
  }

  function edLoadUri(uri, done) {
    var img = new Image();
    img.onload = function () {
      edCanvas.width = img.naturalWidth;
      edCanvas.height = img.naturalHeight;
      edCtx.drawImage(img, 0, 0);
      if (done) done();
    };
    img.src = uri;
  }

  function edExitModes() {
    // Restore the clean base pixels first — selection/crop/piece chrome is
    // painted INTO the canvas, so leaving a mode without repainting would
    // bake the dashed boxes into the image.
    if (edPiece && edBaseCanvas) {
      // A floating piece that was never placed gets flattened where it sits,
      // so switching tools can't silently lose part of the customer's image.
      edCtx.drawImage(edBaseCanvas, 0, 0);
      edCtx.drawImage(edPiece.canvas, edPiece.x, edPiece.y, edPiece.w, edPiece.h);
      edPiece = null;
    } else if (edBaseCanvas) {
      edCtx.drawImage(edBaseCanvas, 0, 0);
    }
    edMode = null;
    edPickedRGB = null;
    edPickedXY = null;
    edLastHex = null;
    edColorBaseData = null;
    edSelRect = null;
    edSelDrawing = false;
    edSelDrag = null;
    edPieceDrag = null;
    edBaseCanvas = null;
    edPieceRestoreUri = null;
    if (edCropBar) edCropBar.hidden = true;
    if (edColorBar) edColorBar.hidden = true;
    if (edSelBar) edSelBar.hidden = true;
    if (edPieceBar) edPieceBar.hidden = true;
    if (edToolCrop) edToolCrop.classList.remove('is-active');
    if (edToolColor) edToolColor.classList.remove('is-active');
    if (edToolSelect) edToolSelect.classList.remove('is-active');
    edDrawOverlayFrame();
    edSetHint('Pick a tool to get started');
  }

  // Offscreen copy of the current pixels — synchronous overlay redraws.
  function edSnapshotBase() {
    edBaseCanvas = document.createElement('canvas');
    edBaseCanvas.width = edCanvas.width;
    edBaseCanvas.height = edCanvas.height;
    edBaseCanvas.getContext('2d').drawImage(edCanvas, 0, 0);
  }

  // Screen-constant sizing: n display px expressed in canvas px at the current
  // zoom, so handles/lines stay a comfortable size however far you zoom in.
  function edPx(n) {
    var rect = edCanvas.getBoundingClientRect();
    var scale = rect.width ? edCanvas.width / rect.width : 1;
    return Math.max(2, n * scale);
  }

  // Median color of a thin ring just OUTSIDE the rect — the surrounding
  // background, used to fill the hole left by Move/Delete.
  function edDetectFillColor(rect) {
    var band = Math.max(3, Math.round(Math.min(rect.w, rect.h) * 0.08));
    var x0 = Math.max(0, Math.round(rect.x - band));
    var y0 = Math.max(0, Math.round(rect.y - band));
    var x1 = Math.min(edCanvas.width, Math.round(rect.x + rect.w + band));
    var y1 = Math.min(edCanvas.height, Math.round(rect.y + rect.h + band));
    var data = edCtx.getImageData(x0, y0, x1 - x0, y1 - y0).data;
    var w = x1 - x0, h = y1 - y0;
    var rs = [], gs = [], bs = [];
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var gx = x0 + x, gy = y0 + y;
        var inside = gx >= rect.x && gx < rect.x + rect.w && gy >= rect.y && gy < rect.y + rect.h;
        if (inside) continue; // only the ring outside the selection
        var i = (y * w + x) * 4;
        rs.push(data[i]); gs.push(data[i + 1]); bs.push(data[i + 2]);
      }
    }
    if (!rs.length) return [255, 255, 255];
    return [median(rs), median(gs), median(bs)];
  }

  function edDrawSelectFrame() {
    if (!edBaseCanvas) return;
    edCtx.drawImage(edBaseCanvas, 0, 0);
    if (!edSelRect) return;
    var r = edSelRect;
    edCtx.save();
    // marching-ants style: black underlay + white dashes
    edCtx.lineWidth = edPx(2);
    edCtx.setLineDash([]);
    edCtx.strokeStyle = 'rgba(0,0,0,0.8)';
    edCtx.strokeRect(r.x, r.y, r.w, r.h);
    edCtx.setLineDash([10, 8]);
    edCtx.strokeStyle = '#ffffff';
    edCtx.strokeRect(r.x, r.y, r.w, r.h);
    var hs = edPx(12);
    var cs = [
      { x: r.x, y: r.y }, { x: r.x + r.w, y: r.y },
      { x: r.x + r.w, y: r.y + r.h }, { x: r.x, y: r.y + r.h },
    ];
    edCtx.setLineDash([]);
    for (var i = 0; i < cs.length; i++) {
      edCtx.fillStyle = '#ffffff';
      edCtx.fillRect(cs[i].x - hs / 2, cs[i].y - hs / 2, hs, hs);
      edCtx.strokeStyle = '#333333';
      edCtx.strokeRect(cs[i].x - hs / 2, cs[i].y - hs / 2, hs, hs);
    }
    edCtx.restore();
  }

  function edDrawPieceFrame() {
    if (!edBaseCanvas || !edPiece) return;
    edCtx.drawImage(edBaseCanvas, 0, 0);
    edCtx.drawImage(edPiece.canvas, edPiece.x, edPiece.y, edPiece.w, edPiece.h);
    edCtx.save();
    edCtx.lineWidth = edPx(2);
    edCtx.setLineDash([10, 8]);
    edCtx.strokeStyle = '#ffffff';
    edCtx.strokeRect(edPiece.x, edPiece.y, edPiece.w, edPiece.h);
    // bottom-right scale handle
    var hs = edPx(14);
    edCtx.setLineDash([]);
    edCtx.fillStyle = '#ffffff';
    edCtx.fillRect(edPiece.x + edPiece.w - hs / 2, edPiece.y + edPiece.h - hs / 2, hs, hs);
    edCtx.strokeStyle = '#333333';
    edCtx.strokeRect(edPiece.x + edPiece.w - hs / 2, edPiece.y + edPiece.h - hs / 2, hs, hs);
    edCtx.restore();
  }

  // Redraw the (possibly cropped-preview) frame: base pixels + crop shading.
  function edDrawOverlayFrame() {
    // Base pixels already live in the canvas; crop preview is drawn via CSS
    // overlay-free approach: we repaint from a snapshot when in crop mode.
    if (edMode === 'crop' && edCropSnapshotUri) {
      var img = new Image();
      img.onload = function () {
        edCtx.drawImage(img, 0, 0);
        // Shade outside the crop rect
        edCtx.save();
        edCtx.fillStyle = 'rgba(15, 23, 42, 0.55)';
        edCtx.beginPath();
        edCtx.rect(0, 0, edCanvas.width, edCanvas.height);
        edCtx.rect(edCrop.x, edCrop.y, edCrop.w, edCrop.h);
        edCtx.fill('evenodd');
        // Crop border + corner handles
        var hs = edPx(14);
        edCtx.setLineDash([12, 8]);
        edCtx.strokeStyle = '#ffffff';
        edCtx.lineWidth = edPx(2);
        edCtx.strokeRect(edCrop.x, edCrop.y, edCrop.w, edCrop.h);
        edCtx.setLineDash([]);
        var cs = edCropCorners();
        for (var i = 0; i < cs.length; i++) {
          edCtx.fillStyle = '#ffffff';
          edCtx.fillRect(cs[i].x - hs / 2, cs[i].y - hs / 2, hs, hs);
          edCtx.strokeStyle = '#333333';
          edCtx.strokeRect(cs[i].x - hs / 2, cs[i].y - hs / 2, hs, hs);
        }
        edCtx.restore();
      };
      img.src = edCropSnapshotUri;
    }
  }

  var edCropSnapshotUri = null;

  function edCropCorners() {
    return [
      { x: edCrop.x, y: edCrop.y },
      { x: edCrop.x + edCrop.w, y: edCrop.y },
      { x: edCrop.x + edCrop.w, y: edCrop.y + edCrop.h },
      { x: edCrop.x, y: edCrop.y + edCrop.h },
    ];
  }

  function edCanvasCoords(e) {
    var rect = edCanvas.getBoundingClientRect();
    var sx = edCanvas.width / rect.width;
    var sy = edCanvas.height / rect.height;
    var cx, cy;
    if (e.touches && e.touches.length) { cx = e.touches[0].clientX; cy = e.touches[0].clientY; }
    else if (e.changedTouches && e.changedTouches.length) { cx = e.changedTouches[0].clientX; cy = e.changedTouches[0].clientY; }
    else { cx = e.clientX; cy = e.clientY; }
    return { x: (cx - rect.left) * sx, y: (cy - rect.top) * sy };
  }

  // --- Change a Color: soft global replacement preserving shading ---
  function edReplaceColor(base, tr, tg, tb, nr, ng, nb) {
    var out = edCtx.createImageData(base.width, base.height);
    var s = base.data, d = out.data;
    var t0 = 45, t1 = 95; // full replace under t0, falloff to t1
    var targetLum = Math.max(1, tr + tg + tb);
    for (var i = 0; i < s.length; i += 4) {
      var r = s[i], g = s[i + 1], b = s[i + 2];
      var dr = r - tr, dg = g - tg, db = b - tb;
      var dist = Math.sqrt(dr * dr + dg * dg + db * db);
      if (dist < t1) {
        var a = dist <= t0 ? 1 : 1 - (dist - t0) / (t1 - t0);
        var shade = Math.min(2, (r + g + b) / targetLum); // keep highlights/shadows
        var rr = Math.min(255, nr * shade);
        var gg = Math.min(255, ng * shade);
        var bb = Math.min(255, nb * shade);
        d[i] = r * (1 - a) + rr * a;
        d[i + 1] = g * (1 - a) + gg * a;
        d[i + 2] = b * (1 - a) + bb * a;
      } else {
        d[i] = r; d[i + 1] = g; d[i + 2] = b;
      }
      d[i + 3] = s[i + 3];
    }
    return out;
  }

  // Paint-bucket variant: flood fill from the tapped pixel — recolors only the
  // CONNECTED region of similar color, not every match in the image.
  function edFloodReplace(base, sx, sy, tr, tg, tb, nr, ng, nb) {
    var w = base.width, h = base.height;
    var s = base.data;
    var out = edCtx.createImageData(w, h);
    out.data.set(s);
    var d = out.data;
    var t0 = 45, t1 = 95;
    var targetLum = Math.max(1, tr + tg + tb);
    var visited = new Uint8Array(w * h);
    var seed = sy * w + sx;
    var stack = [seed];
    visited[seed] = 1;
    while (stack.length) {
      var idx = stack.pop();
      var i = idx * 4;
      var r = s[i], g = s[i + 1], b = s[i + 2];
      var dr = r - tr, dg = g - tg, db = b - tb;
      var dist = Math.sqrt(dr * dr + dg * dg + db * db);
      if (dist >= t1) continue; // region boundary — don't recolor, don't expand
      var a = dist <= t0 ? 1 : 1 - (dist - t0) / (t1 - t0);
      var shade = Math.min(2, (r + g + b) / targetLum);
      d[i] = r * (1 - a) + Math.min(255, nr * shade) * a;
      d[i + 1] = g * (1 - a) + Math.min(255, ng * shade) * a;
      d[i + 2] = b * (1 - a) + Math.min(255, nb * shade) * a;
      var x = idx % w, y = (idx / w) | 0;
      if (x > 0 && !visited[idx - 1]) { visited[idx - 1] = 1; stack.push(idx - 1); }
      if (x < w - 1 && !visited[idx + 1]) { visited[idx + 1] = 1; stack.push(idx + 1); }
      if (y > 0 && !visited[idx - w]) { visited[idx - w] = 1; stack.push(idx - w); }
      if (y < h - 1 && !visited[idx + w]) { visited[idx + w] = 1; stack.push(idx + w); }
    }
    return out;
  }

  function edApplyColorChoice(hex) {
    if (!edPickedRGB || !edColorBaseData) return;
    edLastHex = hex;
    var c = hex.replace('#', '');
    var nr = parseInt(c.slice(0, 2), 16), ng = parseInt(c.slice(2, 4), 16), nb = parseInt(c.slice(4, 6), 16);
    var replaced;
    if (edColorScope === 'spot' && edPickedXY) {
      replaced = edFloodReplace(edColorBaseData, edPickedXY[0], edPickedXY[1], edPickedRGB[0], edPickedRGB[1], edPickedRGB[2], nr, ng, nb);
    } else {
      replaced = edReplaceColor(edColorBaseData, edPickedRGB[0], edPickedRGB[1], edPickedRGB[2], nr, ng, nb);
    }
    edCtx.putImageData(replaced, 0, 0);
    edSetHint('Tap another color to change it too, or Save when done');
  }

  // Build replacement swatches once
  if (edColorSwatches) {
    ED_SWATCHES.forEach(function (col) {
      var sw = document.createElement('button');
      sw.type = 'button';
      sw.className = 'upload-editor__swatch';
      sw.style.backgroundColor = col;
      sw.setAttribute('aria-label', 'Replace with ' + col);
      sw.addEventListener('click', function () { edApplyColorChoice(col); });
      edColorSwatches.appendChild(sw);
    });
  }
  if (edColorCustom) {
    edColorCustom.addEventListener('input', function () { edApplyColorChoice(edColorCustom.value); });
  }
  function edSetScope(scope) {
    edColorScope = scope;
    if (edScopeSpot) edScopeSpot.classList.toggle('is-active', scope === 'spot');
    if (edScopeAll) edScopeAll.classList.toggle('is-active', scope === 'everywhere');
    // Re-apply the chosen color under the new scope so the toggle previews live
    if (edLastHex && edPickedRGB && edColorBaseData) edApplyColorChoice(edLastHex);
  }
  if (edScopeSpot) edScopeSpot.addEventListener('click', function () { edSetScope('spot'); });
  if (edScopeAll) edScopeAll.addEventListener('click', function () { edSetScope('everywhere'); });
  var edColorClose = document.getElementById('ed-color-close');
  if (edColorClose) {
    edColorClose.addEventListener('click', function () {
      // Dismiss the picker; whatever was applied stays (Undo reverts it).
      edPickedRGB = null;
      edPickedXY = null;
      edLastHex = null;
      edColorBaseData = null;
      if (edColorBar) edColorBar.hidden = true;
      edSetHint('Tap any color on your image to change it');
    });
  }

  // --- pointer handling on the editor canvas ---
  function edOnDown(e) {
    if (edMode === 'crop') {
      var pos = edCanvasCoords(e);
      var hs = edPx(22);
      var cs = edCropCorners();
      for (var i = 0; i < cs.length; i++) {
        if (Math.abs(pos.x - cs[i].x) < hs && Math.abs(pos.y - cs[i].y) < hs) {
          edCropDrag = { kind: i, startX: pos.x, startY: pos.y, snap: { x: edCrop.x, y: edCrop.y, w: edCrop.w, h: edCrop.h } };
          e.preventDefault();
          return;
        }
      }
      if (pos.x > edCrop.x && pos.x < edCrop.x + edCrop.w && pos.y > edCrop.y && pos.y < edCrop.y + edCrop.h) {
        edCropDrag = { kind: 'move', startX: pos.x, startY: pos.y, snap: { x: edCrop.x, y: edCrop.y, w: edCrop.w, h: edCrop.h } };
        e.preventDefault();
      }
      return;
    }
    if (edMode === 'select') {
      var sp = edCanvasCoords(e);
      if (edSelRect) {
        var shs = edPx(20);
        var corners = [
          { x: edSelRect.x, y: edSelRect.y }, { x: edSelRect.x + edSelRect.w, y: edSelRect.y },
          { x: edSelRect.x + edSelRect.w, y: edSelRect.y + edSelRect.h }, { x: edSelRect.x, y: edSelRect.y + edSelRect.h },
        ];
        for (var ci = 0; ci < corners.length; ci++) {
          if (Math.abs(sp.x - corners[ci].x) < shs && Math.abs(sp.y - corners[ci].y) < shs) {
            edSelDrag = { kind: ci, startX: sp.x, startY: sp.y, snap: { x: edSelRect.x, y: edSelRect.y, w: edSelRect.w, h: edSelRect.h } };
            e.preventDefault();
            return;
          }
        }
        if (sp.x > edSelRect.x && sp.x < edSelRect.x + edSelRect.w && sp.y > edSelRect.y && sp.y < edSelRect.y + edSelRect.h) {
          edSelDrag = { kind: 'move', startX: sp.x, startY: sp.y, snap: { x: edSelRect.x, y: edSelRect.y, w: edSelRect.w, h: edSelRect.h } };
          e.preventDefault();
          return;
        }
      }
      // Start drawing a fresh box
      edSelRect = { x: sp.x, y: sp.y, w: 1, h: 1 };
      edSelDrawing = true;
      if (edSelBar) edSelBar.hidden = true;
      e.preventDefault();
      return;
    }
    if (edMode === 'piece' && edPiece) {
      var pp = edCanvasCoords(e);
      var phs = edPx(20);
      if (Math.abs(pp.x - (edPiece.x + edPiece.w)) < phs && Math.abs(pp.y - (edPiece.y + edPiece.h)) < phs) {
        edPieceDrag = {
          kind: 'scale',
          startDist: Math.max(1, Math.hypot(pp.x - (edPiece.x + edPiece.w / 2), pp.y - (edPiece.y + edPiece.h / 2))),
          snap: { x: edPiece.x, y: edPiece.y, w: edPiece.w, h: edPiece.h },
        };
        e.preventDefault();
        return;
      }
      edPieceDrag = { kind: 'move', startX: pp.x, startY: pp.y, snap: { x: edPiece.x, y: edPiece.y } };
      e.preventDefault();
      return;
    }
    if (edMode === 'color') {
      var p = edCanvasCoords(e);
      var px = Math.max(0, Math.min(edCanvas.width - 1, Math.round(p.x)));
      var py = Math.max(0, Math.min(edCanvas.height - 1, Math.round(p.y)));
      // Commit any in-progress replacement, then pick the new target
      edPushUndo();
      edColorBaseData = edCtx.getImageData(0, 0, edCanvas.width, edCanvas.height);
      var one = edCtx.getImageData(px, py, 1, 1).data;
      edPickedRGB = [one[0], one[1], one[2]];
      edPickedXY = [px, py];
      edLastHex = null; // fresh pick — wait for a color choice
      if (edColorFrom) edColorFrom.style.backgroundColor = 'rgb(' + one[0] + ',' + one[1] + ',' + one[2] + ')';
      if (edColorBar) edColorBar.hidden = false;
      edSetHint('Now choose the new color');
      e.preventDefault();
    }
  }

  function edOnMove(e) {
    if (edMode === 'select' && (edSelDrawing || edSelDrag)) {
      var sp = edCanvasCoords(e);
      var cw = edCanvas.width, ch = edCanvas.height;
      sp.x = Math.max(0, Math.min(cw, sp.x));
      sp.y = Math.max(0, Math.min(ch, sp.y));
      if (edSelDrawing) {
        edSelRect.w = sp.x - edSelRect.x;
        edSelRect.h = sp.y - edSelRect.y;
      } else if (edSelDrag) {
        var dx = sp.x - edSelDrag.startX, dy = sp.y - edSelDrag.startY;
        var s = edSelDrag.snap;
        var MINS = Math.max(20, cw / 40);
        if (edSelDrag.kind === 'move') {
          edSelRect.x = Math.max(0, Math.min(cw - s.w, s.x + dx));
          edSelRect.y = Math.max(0, Math.min(ch - s.h, s.y + dy));
        } else {
          var x2 = s.x + s.w, y2 = s.y + s.h;
          if (edSelDrag.kind === 0) { edSelRect.x = Math.max(0, Math.min(x2 - MINS, s.x + dx)); edSelRect.y = Math.max(0, Math.min(y2 - MINS, s.y + dy)); edSelRect.w = x2 - edSelRect.x; edSelRect.h = y2 - edSelRect.y; }
          if (edSelDrag.kind === 1) { edSelRect.w = Math.max(MINS, Math.min(cw - s.x, s.w + dx)); edSelRect.y = Math.max(0, Math.min(y2 - MINS, s.y + dy)); edSelRect.h = y2 - edSelRect.y; }
          if (edSelDrag.kind === 2) { edSelRect.w = Math.max(MINS, Math.min(cw - s.x, s.w + dx)); edSelRect.h = Math.max(MINS, Math.min(ch - s.y, s.h + dy)); }
          if (edSelDrag.kind === 3) { edSelRect.x = Math.max(0, Math.min(x2 - MINS, s.x + dx)); edSelRect.w = x2 - edSelRect.x; edSelRect.h = Math.max(MINS, Math.min(ch - s.y, s.h + dy)); }
        }
      }
      // normalize negative width/height while drawing
      var draw2 = { x: edSelRect.x, y: edSelRect.y, w: edSelRect.w, h: edSelRect.h };
      if (draw2.w < 0) { draw2.x += draw2.w; draw2.w = -draw2.w; }
      if (draw2.h < 0) { draw2.y += draw2.h; draw2.h = -draw2.h; }
      var keep = edSelRect;
      edSelRect = draw2;
      edDrawSelectFrame();
      edSelRect = keep;
      e.preventDefault();
      return;
    }
    if (edMode === 'piece' && edPieceDrag && edPiece) {
      var pp = edCanvasCoords(e);
      if (edPieceDrag.kind === 'move') {
        edPiece.x = edPieceDrag.snap.x + (pp.x - edPieceDrag.startX);
        edPiece.y = edPieceDrag.snap.y + (pp.y - edPieceDrag.startY);
      } else {
        var snapP = edPieceDrag.snap;
        var cx2 = snapP.x + snapP.w / 2, cy2 = snapP.y + snapP.h / 2;
        var ratio = Math.max(0.15, Math.min(4, Math.hypot(pp.x - cx2, pp.y - cy2) / edPieceDrag.startDist));
        edPiece.w = snapP.w * ratio;
        edPiece.h = snapP.h * ratio;
        edPiece.x = cx2 - edPiece.w / 2;
        edPiece.y = cy2 - edPiece.h / 2;
      }
      edDrawPieceFrame();
      e.preventDefault();
      return;
    }
    if (edMode !== 'crop' || !edCropDrag) return;
    var pos = edCanvasCoords(e);
    var dx = pos.x - edCropDrag.startX;
    var dy = pos.y - edCropDrag.startY;
    var s = edCropDrag.snap;
    var MIN = Math.max(40, edCanvas.width / 20);
    if (edCropDrag.kind === 'move') {
      edCrop.x = Math.max(0, Math.min(edCanvas.width - s.w, s.x + dx));
      edCrop.y = Math.max(0, Math.min(edCanvas.height - s.h, s.y + dy));
    } else {
      var x2 = s.x + s.w, y2 = s.y + s.h;
      if (edCropDrag.kind === 0) { edCrop.x = Math.max(0, Math.min(x2 - MIN, s.x + dx)); edCrop.y = Math.max(0, Math.min(y2 - MIN, s.y + dy)); edCrop.w = x2 - edCrop.x; edCrop.h = y2 - edCrop.y; }
      if (edCropDrag.kind === 1) { edCrop.w = Math.max(MIN, Math.min(edCanvas.width - s.x, s.w + dx)); edCrop.y = Math.max(0, Math.min(y2 - MIN, s.y + dy)); edCrop.h = y2 - edCrop.y; }
      if (edCropDrag.kind === 2) { edCrop.w = Math.max(MIN, Math.min(edCanvas.width - s.x, s.w + dx)); edCrop.h = Math.max(MIN, Math.min(edCanvas.height - s.y, s.h + dy)); }
      if (edCropDrag.kind === 3) { edCrop.x = Math.max(0, Math.min(x2 - MIN, s.x + dx)); edCrop.w = x2 - edCrop.x; edCrop.h = Math.max(MIN, Math.min(edCanvas.height - s.y, s.h + dy)); }
    }
    edDrawOverlayFrame();
    e.preventDefault();
  }

  function edOnUp() {
    edCropDrag = null;
    edPieceDrag = null;
    edSelDrag = null;
    if (edSelDrawing) {
      edSelDrawing = false;
      // normalize the drawn box
      if (edSelRect) {
        if (edSelRect.w < 0) { edSelRect.x += edSelRect.w; edSelRect.w = -edSelRect.w; }
        if (edSelRect.h < 0) { edSelRect.y += edSelRect.h; edSelRect.h = -edSelRect.h; }
        var MINS = Math.max(20, edCanvas.width / 40);
        if (edSelRect.w < MINS || edSelRect.h < MINS) {
          edSelRect = null; // too small — treat as a stray tap
          edDrawSelectFrame();
          edSetHint('Drag a box around the part you want to move or remove');
        } else {
          if (edSelBar) edSelBar.hidden = false;
          edDrawSelectFrame();
          edSetHint('Move it, delete it (the gap fills with the surrounding color), or cancel');
        }
      }
    }
  }

  if (edCanvas) {
    edCanvas.addEventListener('mousedown', edOnDown);
    edCanvas.addEventListener('mousemove', edOnMove);
    window.addEventListener('mouseup', edOnUp);
    edCanvas.addEventListener('touchstart', edOnDown, { passive: false });
    edCanvas.addEventListener('touchmove', edOnMove, { passive: false });
    window.addEventListener('touchend', edOnUp);
  }

  // --- tool buttons ---
  if (edToolCrop) {
    edToolCrop.addEventListener('click', function () {
      // Clicking a tool always (re)arms it fresh — no toggle-off.
      edExitModes();
      edMode = 'crop';
      edToolCrop.classList.add('is-active');
      edSnapshotBase();
      edCropSnapshotUri = edCanvas.toDataURL('image/png');
      var inset = Math.round(Math.min(edCanvas.width, edCanvas.height) * 0.1);
      edCrop = { x: inset, y: inset, w: edCanvas.width - inset * 2, h: edCanvas.height - inset * 2 };
      if (edCropBar) edCropBar.hidden = false;
      edSetHint('Drag the corners around the part you want to keep');
      edDrawOverlayFrame();
    });
  }
  if (edCropApply) {
    edCropApply.addEventListener('click', function () {
      if (edMode !== 'crop' || !edCropSnapshotUri) return;
      var img = new Image();
      img.onload = function () {
        edPushUndo();
        var c = document.createElement('canvas');
        c.width = Math.round(edCrop.w);
        c.height = Math.round(edCrop.h);
        c.getContext('2d').drawImage(img, edCrop.x, edCrop.y, edCrop.w, edCrop.h, 0, 0, c.width, c.height);
        edCanvas.width = c.width;
        edCanvas.height = c.height;
        edCtx.drawImage(c, 0, 0);
        edCropSnapshotUri = null;
        edBaseCanvas = null; // canvas was legitimately replaced — don't repaint the pre-crop base
        edExitModes();
        requestAnimationFrame(edCaptureFitWidth); // dimensions changed — re-fit and reset zoom
      };
      img.src = edCropSnapshotUri;
    });
  }
  if (edCropCancel) {
    edCropCancel.addEventListener('click', function () {
      if (edCropSnapshotUri) {
        edLoadUri(edCropSnapshotUri, function () { edCropSnapshotUri = null; edExitModes(); });
      } else {
        edExitModes();
      }
    });
  }
  if (edToolColor) {
    edToolColor.addEventListener('click', function () {
      edExitModes();
      edMode = 'color';
      edToolColor.classList.add('is-active');
      edSetHint('Tap any color on your image to change it');
    });
  }
  if (edToolSelect) {
    edToolSelect.addEventListener('click', function () {
      edExitModes();
      edMode = 'select';
      edToolSelect.classList.add('is-active');
      edSnapshotBase();
      edSetHint('Drag a box around the part you want to move or remove');
    });
  }
  if (edSelCancel) {
    edSelCancel.addEventListener('click', function () {
      edSelRect = null;
      if (edSelBar) edSelBar.hidden = true;
      edDrawSelectFrame();
      edSetHint('Drag a box around the part you want to move or remove');
    });
  }
  if (edSelDelete) {
    edSelDelete.addEventListener('click', function () {
      if (!edSelRect) return;
      // repaint clean base (no selection chrome), then fill the region
      edCtx.drawImage(edBaseCanvas, 0, 0);
      edPushUndo();
      var fill = edDetectFillColor(edSelRect);
      edCtx.fillStyle = 'rgb(' + fill[0] + ',' + fill[1] + ',' + fill[2] + ')';
      edCtx.fillRect(edSelRect.x, edSelRect.y, edSelRect.w, edSelRect.h);
      edSnapshotBase();
      edSelRect = null;
      if (edSelBar) edSelBar.hidden = true;
      edSetHint('Deleted. Select another part, or Save when done');
    });
  }
  if (edSelMove) {
    edSelMove.addEventListener('click', function () {
      if (!edSelRect) return;
      var r = {
        x: Math.round(edSelRect.x), y: Math.round(edSelRect.y),
        w: Math.round(edSelRect.w), h: Math.round(edSelRect.h),
      };
      // clean base (no selection chrome), remember it for "Undo Move"
      edCtx.drawImage(edBaseCanvas, 0, 0);
      edPieceRestoreUri = edCanvas.toDataURL('image/png');
      edPushUndo();
      // lift the piece
      var pc = document.createElement('canvas');
      pc.width = r.w; pc.height = r.h;
      pc.getContext('2d').drawImage(edCanvas, r.x, r.y, r.w, r.h, 0, 0, r.w, r.h);
      // fill the hole with the surrounding color
      var fill = edDetectFillColor(r);
      edCtx.fillStyle = 'rgb(' + fill[0] + ',' + fill[1] + ',' + fill[2] + ')';
      edCtx.fillRect(r.x, r.y, r.w, r.h);
      edSnapshotBase();
      edPiece = { canvas: pc, x: r.x, y: r.y, w: r.w, h: r.h };
      edSelRect = null;
      edMode = 'piece';
      if (edSelBar) edSelBar.hidden = true;
      if (edPieceBar) edPieceBar.hidden = false;
      edDrawPieceFrame();
      edSetHint('Drag it into place · drag the corner to resize · then Place It');
    });
  }
  if (edPiecePlace) {
    edPiecePlace.addEventListener('click', function () {
      if (!edPiece) return;
      edCtx.drawImage(edBaseCanvas, 0, 0);
      edCtx.drawImage(edPiece.canvas, edPiece.x, edPiece.y, edPiece.w, edPiece.h);
      edPiece = null;
      edPieceRestoreUri = null;
      if (edPieceBar) edPieceBar.hidden = true;
      // straight back into select mode — they often have more pieces to fix
      edMode = 'select';
      if (edToolSelect) edToolSelect.classList.add('is-active');
      edSnapshotBase();
      edSetHint('Placed. Select another part, or Save when done');
    });
  }
  if (edPieceCancel) {
    edPieceCancel.addEventListener('click', function () {
      if (!edPieceRestoreUri) return;
      edPiece = null; // clear FIRST so edExitModes doesn't flatten it
      edUndoStack.pop(); // drop the undo entry the Move pushed
      edUpdateHistoryButtons();
      edLoadUri(edPieceRestoreUri, function () {
        edPieceRestoreUri = null;
        if (edPieceBar) edPieceBar.hidden = true;
        edMode = 'select';
        if (edToolSelect) edToolSelect.classList.add('is-active');
        edSnapshotBase();
        edSetHint('Drag a box around the part you want to move or remove');
      });
    });
  }

  // --- history ---
  if (edUndoBtn) {
    edUndoBtn.addEventListener('click', function () {
      if (!edUndoStack.length) return;
      // Exit modes FIRST: restores clean pixels (no selection chrome in the
      // redo snapshot) and prevents the exit repaint from stomping the
      // freshly-loaded undo state.
      edExitModes();
      edRedoStack.push(edCanvas.toDataURL('image/png'));
      edLoadUri(edUndoStack.pop(), function () { edUpdateHistoryButtons(); });
    });
  }
  if (edRedoBtn) {
    edRedoBtn.addEventListener('click', function () {
      if (!edRedoStack.length) return;
      edExitModes();
      edUndoStack.push(edCanvas.toDataURL('image/png'));
      edLoadUri(edRedoStack.pop(), function () { edUpdateHistoryButtons(); });
    });
  }
  if (edResetBtn) {
    edResetBtn.addEventListener('click', function () {
      if (!edOriginalUri) return;
      edExitModes();
      edUndoStack.length = 0;
      edRedoStack.length = 0;
      edLoadUri(edOriginalUri, function () { edUpdateHistoryButtons(); });
    });
  }

  // --- zoom ---
  var edStage = document.getElementById('ed-stage');
  var edZoomIn = document.getElementById('ed-zoom-in');
  var edZoomOut = document.getElementById('ed-zoom-out');
  var edZoomFit = document.getElementById('ed-zoom-fit');
  var edZoom = 1;
  var edFitWidth = 0; // displayed width at zoom 1, captured on open / after crop

  function edRedrawMode() {
    if (edMode === 'crop') edDrawOverlayFrame();
    else if (edMode === 'select') edDrawSelectFrame();
    else if (edMode === 'piece') edDrawPieceFrame();
  }

  function edCaptureFitWidth() {
    edCanvas.style.width = '';
    edCanvas.style.maxWidth = '';
    edCanvas.style.maxHeight = '';
    edZoom = 1;
    var r = edCanvas.getBoundingClientRect();
    edFitWidth = r.width || 0;
  }

  function edApplyZoom(z) {
    if (!edStage || !edFitWidth) return;
    z = Math.max(1, Math.min(8, z));
    var oldW = edCanvas.getBoundingClientRect().width || edFitWidth;
    if (z === 1) {
      edCanvas.style.width = '';
      edCanvas.style.maxWidth = '';
      edCanvas.style.maxHeight = '';
    } else {
      edCanvas.style.maxWidth = 'none';
      edCanvas.style.maxHeight = 'none';
      edCanvas.style.width = Math.round(edFitWidth * z) + 'px';
    }
    edZoom = z;
    // keep the view centered on the same spot while zooming
    var vw = edStage.clientWidth, vh = edStage.clientHeight;
    var newW = z === 1 ? edFitWidth : edFitWidth * z;
    var ratio = newW / Math.max(1, oldW);
    edStage.scrollLeft = (edStage.scrollLeft + vw / 2) * ratio - vw / 2;
    edStage.scrollTop = (edStage.scrollTop + vh / 2) * ratio - vh / 2;
    edRedrawMode(); // handles are screen-constant — repaint them at the new scale
  }

  if (edZoomIn) edZoomIn.addEventListener('click', function () { edApplyZoom(edZoom * 1.5); });
  if (edZoomOut) edZoomOut.addEventListener('click', function () { edApplyZoom(edZoom / 1.5); });
  if (edZoomFit) edZoomFit.addEventListener('click', function () { edApplyZoom(1); });
  if (edStage) {
    edStage.addEventListener('wheel', function (e) {
      if (!e.ctrlKey) return; // plain scroll pans; ctrl+scroll zooms (browser convention)
      e.preventDefault();
      edApplyZoom(edZoom * (e.deltaY < 0 ? 1.15 : 1 / 1.15));
    }, { passive: false });
  }

  // --- open / cancel / save ---
  if (editImgBtn) {
    editImgBtn.addEventListener('click', function () {
      var src = fitSourceImg || currentImg;
      if (!src || !edOverlay) return;
      var w = src.naturalWidth, h = src.naturalHeight;
      var scale = Math.min(1, ED_MAX_PX / Math.max(w, h));
      edCanvas.width = Math.round(w * scale);
      edCanvas.height = Math.round(h * scale);
      edCtx.drawImage(src, 0, 0, edCanvas.width, edCanvas.height);
      edOpenedSource = src;
      edOpenedW = edCanvas.width;
      edOpenedH = edCanvas.height;
      if (edTextNote) edTextNote.hidden = textLayers.length === 0;
      edOriginalUri = edCanvas.toDataURL('image/png');
      edUndoStack.length = 0;
      edRedoStack.length = 0;
      edUpdateHistoryButtons();
      edExitModes();
      edOverlay.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(edCaptureFitWidth); // measure the fitted size once laid out
    });
  }
  function edClose() {
    if (edOverlay) edOverlay.hidden = true;
    document.body.style.overflow = '';
    edExitModes();
  }
  if (edCancelBtn) edCancelBtn.addEventListener('click', edClose);
  if (edApplyBtn) {
    edApplyBtn.addEventListener('click', function () {
      edExitModes(); // flatten any floating piece + strip mode chrome first
      // If the dimensions didn't change (no crop) and the editor was editing
      // the image the sign is showing, KEEP the sign placement — text layers
      // sit in sign-space, so this keeps text aligned over the image.
      var preserve =
        edOpenedSource === currentImg &&
        edCanvas.width === edOpenedW &&
        edCanvas.height === edOpenedH;
      var uri = edCanvas.toDataURL('image/png');
      var img = new Image();
      img.onload = function () {
        currentImg = img;
        fitSourceImg = img;
        if (!preserve) {
          rotation = 0;
          resetImagePosition();
        }
        draw();
        showControls();
        edClose();
      };
      img.src = uri;
    });
  }

  function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
  function hideError() { errorEl.hidden = true; }

  function showControls() {
    // Hides the "Select Your Image" overlay CTA on the frame.
    container.classList.add('ai-design-generator--has-image');
    if (resetBtn) resetBtn.hidden = false;
    if (aifitBtn) aifitBtn.hidden = false;
    if (aifitNote) aifitNote.hidden = false;
    if (addTextBtn) addTextBtn.hidden = false;
    if (editImgBtn) editImgBtn.hidden = false;
    if (hintEl) hintEl.hidden = false;
    setAddToCartEnabled(true); // a design is loaded — safe to allow add-to-cart now
  }

  // Move preview modal + editor overlay to body (the section wrapper is
  // display:none'd after the gallery move, which would hide them).
  if (previewModal) document.body.appendChild(previewModal);
  if (edOverlay) document.body.appendChild(edOverlay);

  // Move upload generator into the gallery column
  var galleryWrap = document.querySelector('product-page .flickity-container');
  if (galleryWrap) {
    var sectionWrap = container.closest('.ai-design-generator-section');
    Array.from(galleryWrap.children).forEach(function (child) { child.style.display = 'none'; });
    galleryWrap.classList.remove('element--is-sticky');
    galleryWrap.appendChild(container);
    if (sectionWrap) sectionWrap.style.display = 'none';
  }

  loadFrame();
})();
